import React from 'react';
import { Section, FadeIn } from './ui';
import { Check } from 'lucide-react';
export const StorySection = () => {
  const painPoints = ['Llevas tanto tiempo siendo "la fuerte" que ya no sabes cómo pedir ayuda', 'Dices "estoy bien" aunque por dentro algo se está rompiendo', 'Sientes que si tú no estás, todo se derrumba — pero cuando estás, nadie lo nota', 'Has llorado sola, en el baño, para que nadie te vea', 'Te preguntas si algún día alguien te va a cuidar a ti como tú cuidas a todos', 'A veces sientes que te perdiste en algún punto del camino y ya no sabes quién eres sin los demás'];
  return <Section className="bg-cream-100" data-id="element-235">
      <FadeIn data-id="element-236">
        <div className="text-base sm:text-xl leading-relaxed text-gray-700 mb-6 sm:mb-10" data-id="element-237">
          <p className="mb-3 sm:mb-4" data-id="element-238">Sé que estás cansada.</p>
          <p className="mb-3 sm:mb-4" data-id="element-239">
            No el cansancio que se va con una buena noche de sueño. Sino ese
            otro cansancio — el que está en los huesos, en el alma, en ese lugar
            profundo donde guardas todo lo que nunca dices.
          </p>
          <p data-id="element-240">
            El cansancio de dar siempre, de aguantar siempre, de resolver
            siempre... para todos, menos para ti.
          </p>
        </div>

        <h3 className="text-xl sm:text-3xl mb-4 sm:mb-6 text-center font-serif italic text-navy-800" data-id="element-241">
          ¿Te suena familiar?
        </h3>

        <div className="space-y-1 sm:space-y-3 mb-6 sm:mb-10" data-id="element-242">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3 p-2 sm:p-3 rounded-xl" data-id="element-243">
              <div className="mt-1 bg-rose-100 text-rose-500 rounded-full p-1 shrink-0" data-id="element-244">
                <Check size={16} strokeWidth={3} data-id="element-245" />
              </div>
              <p className="text-sm sm:text-lg text-gray-700" data-id="element-246">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-247">
          <p className="text-lg sm:text-2xl font-medium text-navy-900 mb-1" data-id="element-248">
            Si dijiste "sí" a cualquiera de estas...
          </p>
          <p className="text-lg sm:text-2xl font-serif italic text-rose-500" data-id="element-249">
            Necesito que sigas leyendo.
          </p>
        </div>
      </FadeIn>
    </Section>;
};